const CheckedIcon = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="11"
      height="8"
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.76673 6.27513L1.49173 3.82513L0.733398 4.6418L3.76673 7.90846L10.2667 0.908464L9.5084 0.0917969L3.76673 6.27513Z"
        fill={color}
      />
    </svg>
  );
};

export default CheckedIcon;
